export default class {
    constructor (lodash) {
        this.lodash = lodash;
    }

    mapSelectItems (result, level) {
        if (level === undefined) {
            level = 0;
        }
        const pad = '\u2003';
        let selectItems = [];
        this.lodash.forEach(result, item => {
            selectItems.push({
                id: item.id,
                name: this.lodash.repeat(pad, level) + item.activeI18n.name
            });
            if (item.childCategories.length) {
                selectItems = selectItems.concat(this.mapSelectItems(item.childCategories, level + 1));
            }
        });
        return selectItems;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/form/category/index.js